/* eslint-disable no-unused-vars */
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../common/Modal';
import '../../assets/css/pages/stores/price-search.css';
import {
    setBaika,
    setCommon,
    setDeleteConfirm,
    setEdlp,
    setExcelValidation,
    setExportError,
    setFiftyDiscount,
    setIsContinue,
    setIsDeleteContinue,
    setIsEdlpContinue,
    setIsPriceValidContinue,
    setIsVariantProductsContinue,
    setLimitOver,
    setNbpbkbn,
    setPriceValid,
    setProhibited,
    setProhibitedItem,
    setShowTableLimitOver,
    setTenDiscount,
    setThirtyDiscount,
    setVariantProducts,
} from '../../redux/actions/modal';
import ViewTable from '../tables/ViewTable';
import {
    getEdlpTable,
    getExcelValidationTable,
    getLowerLimitTable,
    getNbpbkbnTable,
    getProhibitedItemsTable,
    getProhibitedTable,
    getVariantProductsTable,
} from '../tables/table';

const CommonModals = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const storage = useSelector((state) => state.storage);
    const { isFreshness } = storage;

    const modal = useSelector((state) => state.modal);
    const {
        fiftyDiscount, // 50%乖離
        thirtyDiscount, // 30%乖離
        tenDiscount, // 10%乖離
        limitOver, // 下限値超過
        showTableLimitOver, // 下限値超過
        prohibited, // 禁止商品・カテゴリー
        prohibitedItem, // 禁止商品
        nbpbkbn, // PB・留型
        excelValidation, // Excelバリデーション
        edlp, // edlp
        priceValid, // 更徳
        deleteConfirm, // 削除確認
        baika,
        common, // 共通
        exportError,
        variantProducts,
    } = modal;

    const lowerLimitTable = getLowerLimitTable(t);
    const prohibitedTable = getProhibitedTable(t, isFreshness);
    const prohibitedItemTable = getProhibitedItemsTable(t, isFreshness);
    const nbpbkbnTable = getNbpbkbnTable(t);
    const excelValidationTable = getExcelValidationTable(t);
    const edlpTable = getEdlpTable(t, isFreshness);
    const variantProductsTable = getVariantProductsTable(t);

    return (
        <>
            <Modal
                size="xl"
                isShow={fiftyDiscount.isShow}
                onClose={() => dispatch(setFiftyDiscount())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('modal.fifty_percent_selling_price_modal.button'),
                        className: 'btn--primary',
                        onClick: () => dispatch(setFiftyDiscount()),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('modal.fifty_percent_selling_price_modal.body.text01')}</p>
                        <p className="text-center">{t('modal.fifty_percent_selling_price_modal.body.text02')}</p>
                        <ViewTable heads={edlpTable.heads} body={edlpTable.body} dataTable={fiftyDiscount.items} />
                    </>
                }
            />
            <Modal
                size="xl"
                isShow={thirtyDiscount.isShow}
                onClose={() => dispatch(setThirtyDiscount())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('modal.thirty_percent_selling_price_modal.button.primary'),
                        className: 'btn--primary',
                        onClick: () => {
                            dispatch(setIsContinue(true));
                            dispatch(setThirtyDiscount());
                        },
                        disabled: false,
                    },
                    {
                        name: t('modal.thirty_percent_selling_price_modal.button.secondary'),
                        className: 'btn--secondary master-edit-modal__submit',
                        onClick: () => dispatch(setThirtyDiscount()),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('modal.thirty_percent_selling_price_modal.body.text01')}</p>
                        <p className="text-center">{t('modal.thirty_percent_selling_price_modal.body.text02')}</p>
                        <ViewTable heads={edlpTable.heads} body={edlpTable.body} dataTable={thirtyDiscount.items} />
                    </>
                }
            />
            <Modal
                size="xl"
                isShow={tenDiscount.isShow}
                onClose={() => dispatch(setTenDiscount())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('modal.ten_percent_selling_price_modal.button.registration'),
                        className: 'btn--primary',
                        onClick: () => {
                            dispatch(setIsContinue(true));
                            dispatch(setTenDiscount());
                        },
                        disabled: false,
                    },
                    {
                        name: t('modal.ten_percent_selling_price_modal.button.cancel'),
                        className: 'btn--secondary master-edit-modal__submit',
                        onClick: () => dispatch(setTenDiscount()),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('modal.ten_percent_selling_price_modal.body.first_content')}</p>
                        <p className="text-center">{t('modal.ten_percent_selling_price_modal.body.second_content')}</p>
                        <ViewTable heads={edlpTable.heads} body={edlpTable.body} dataTable={tenDiscount.items} />
                    </>
                }
            />
            <Modal
                size="xl"
                isShow={limitOver.isShow}
                onClose={() => dispatch(setLimitOver())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: '閉じる',
                        className: 'btn btn--secondary',
                        onClick: () => dispatch(setLimitOver()),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('modal.error_modal.body.first_content')}</p>
                        <p className="text-center">{t('modal.error_modal.body.second_content')}</p>
                        <ViewTable heads={prohibitedTable.heads} body={prohibitedTable.body} dataTable={limitOver.items} />
                    </>
                }
            />
            <Modal
                isShow={showTableLimitOver.isShow}
                onClose={() => dispatch(setShowTableLimitOver())}
                size="sm"
                title={t('modal.common_modal.title')}
                isShowIconClose="true"
                btnList={[
                    {
                        name: t('price_registration.competitor_prohibited_items_modal.body.button'),
                        className: 'btn--primary',
                        onClick: () => dispatch(setShowTableLimitOver()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_registration.competitor_prohibited_items_modal.body.text01')}</p>
                        <ViewTable heads={lowerLimitTable.heads} body={lowerLimitTable.body} dataTable={showTableLimitOver.items} />
                    </>
                }
            />
            <Modal
                size="xl"
                isShow={prohibited.isShow}
                onClose={() => dispatch(setProhibited())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('confirm_registration_price.modal_prohibited.button_ok'),
                        className: 'btn--secondary',
                        onClick: () => dispatch(setProhibited()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('confirm_registration_price.modal_prohibited.first_content')}</p>
                        <ViewTable heads={prohibitedTable.heads} body={prohibitedTable.body} dataTable={prohibited.items} />
                    </>
                }
            />
            <Modal
                size="xl"
                isShow={prohibitedItem.isShow}
                onClose={() => dispatch(setProhibitedItem())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('confirm_registration_price.modal_prohibited.button_ok'),
                        className: 'btn--secondary',
                        onClick: () => dispatch(setProhibitedItem()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_registration.prohibited_modal.message')}</p>
                        <ViewTable heads={prohibitedItemTable.heads} body={prohibitedItemTable.body} dataTable={prohibitedItem.items} />
                    </>
                }
            />
            <Modal
                size="xl"
                isShow={nbpbkbn.isShow}
                onClose={() => dispatch(setNbpbkbn())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('price_registration.nbpbkbn_modal.button_ok'),
                        className: 'btn--secondary',
                        onClick: () => dispatch(setNbpbkbn()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_registration.nbpbkbn_modal.message')}</p>
                        <ViewTable heads={nbpbkbnTable.heads} body={nbpbkbnTable.body} dataTable={nbpbkbn.items} />
                    </>
                }
            />
            <Modal
                size="sm"
                isShow={excelValidation.isShow}
                onClose={() => dispatch(setExcelValidation())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('confirm_registration_price.modal_prohibited.button_ok'),
                        className: 'btn--secondary',
                        onClick: () => dispatch(setExcelValidation()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{'入力情報に誤りがあります'}</p>
                        <ViewTable heads={excelValidationTable.heads} body={excelValidationTable.body} dataTable={excelValidation.items} />
                    </>
                }
            />
            <Modal
                size="sm"
                isShow={deleteConfirm}
                onClose={() => dispatch(setDeleteConfirm(false))}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('button.delete'),
                        className: 'btn--primary',
                        onClick: () => {
                            dispatch(setIsDeleteContinue(true));
                            dispatch(setDeleteConfirm(false));
                        },
                        disabled: false,
                    },
                    {
                        name: t('button.cancel'),
                        className: 'btn--secondary master-edit-modal__submit',
                        onClick: () => dispatch(setDeleteConfirm(false)),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p class="text-center">{t('message.info.please.select.data.to.delete.title')}</p>
                        <p class="text-center">{t('message.info.please.select.data.to.delete.delete_success')}</p>
                    </>
                }
            />
            <Modal
                size="sm"
                isShow={common.isShow}
                onClose={() => dispatch(setCommon())}
                isShowIconClose="true"
                title={common.title}
                btnList={[
                    {
                        name: '閉じる',
                        className: 'btn btn--secondary',
                        onClick: () => dispatch(setCommon()),
                        disabled: false,
                    },
                ]}
                children={common.body.split('\n').map((item, key) => {
                    return (
                        <p key={key} className="text-center">
                            {item}
                        </p>
                    );
                })}
            />
            <Modal
                isShow={edlp.isShow}
                onClose={() => dispatch(setEdlp())}
                isShowIconClose="true"
                size="xll"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => {
                            dispatch(setEdlp());
                        },
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_request.application-modal.title')}</p>
                        <ViewTable heads={edlpTable.heads} body={edlpTable.body} dataTable={edlp.items} />
                    </>
                }
            />
            <Modal
                isShow={priceValid.isShow}
                onClose={() => dispatch(setPriceValid())}
                isShowIconClose="true"
                size="xll"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => {
                            dispatch(setPriceValid());
                        },
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">
                            {'入力した売価以下の更徳・超目が、入力した期間よりも長く登録されているため、登録できません。'}
                        </p>
                        <ViewTable heads={edlpTable.heads} body={edlpTable.body} dataTable={priceValid.items} />
                    </>
                }
            />
            <Modal
                size="sm"
                isShow={baika.isShow}
                onClose={() => dispatch(setBaika())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('price_registration.baika_modal.button_ok'),
                        className: 'btn--secondary',
                        onClick: () => dispatch(setBaika()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_registration.baika_modal.message')}</p>
                    </>
                }
            />
            <Modal
                size="lg"
                isShow={exportError.isShow}
                onClose={() => dispatch(setExportError())}
                isShowIconClose="true"
                title={exportError.title}
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--secondary',
                        onClick: () => dispatch(setExportError()),
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{exportError.text01}</p>
                    </>
                }
            />
            <Modal
                size="lg"
                isShow={variantProducts.isShow}
                onClose={() => dispatch(setVariantProducts())}
                isShowIconClose="true"
                title={t('modal.common_modal.title')}
                btnList={[
                    {
                        name: t('button.registration'),
                        className: 'btn--primary',
                        onClick: () => {
                            dispatch(setIsVariantProductsContinue(true));
                            dispatch(setVariantProducts());
                        },
                    },
                    {
                        name: t('button.cancel'),
                        className: 'btn--secondary master-edit-modal__submit',
                        onClick: () => dispatch(setVariantProducts()),
                        disabled: false,
                    },
                ]}
                children={
                    <>
                        <p className="text-center">{t('price_registration.different_capacity.text01')}</p>
                        <p className="text-center">{t('price_registration.different_capacity.text02')}</p>
                        <p className="text-center">{t('price_registration.different_capacity.text03')}</p>
                        <ViewTable heads={variantProductsTable.heads} body={variantProductsTable.body} dataTable={variantProducts.items} />
                    </>
                }
            />
        </>
    );
};

export default CommonModals;
